module.exports = __webpack_public_path__ + "static/img/bg_naturally_salt.e7bbe06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/bg/bg_naturally_salt.jpg
// module id = h6dM
// module chunks = 4